import {ImageOutputFormat} from "vtom-api-typescript-client";

export class ImageOutputFormats {
    static toLabelCode(value: ImageOutputFormat): string {
        return 'imageprocessing.output.format.' + value.toLowerCase();
    }
}
